import { TOptions, t as t18 } from "i18next";

export const namespaces = [
  'common', 'auth', 'app'
]
  ;
export const AvailableLocales = ['sv-SE', 'nl-NL', 'fr-FR', 'en-US', 'en-GB'] as const;

export type AvailableLocaleType = (typeof AvailableLocales)[number];

export const tCommon = {
  actions: {
    cancel(options: TOptions = {}) {
      return t18('common:actions.cancel', options);
    },
    close(options: TOptions = {}) {
      return t18('common:actions.close', options);
    },
    continue(options: TOptions = {}) {
      return t18('common:actions.continue', options);
    },
    foo(options: TOptions = {}) {
      return t18('common:actions.foo', options);
    },
    goBack(options: TOptions = {}) {
      return t18('common:actions.goBack', options);
    },
    hide(options: TOptions = {}) {
      return t18('common:actions.hide', options);
    },
    offline(options: TOptions = {}) {
      return t18('common:actions.offline', options);
    },
    open(options: TOptions = {}) {
      return t18('common:actions.open', options);
    },
    orderNow(options: TOptions = {}) {
      return t18('common:actions.orderNow', options);
    },
    retry(options: TOptions = {}) {
      return t18('common:actions.retry', options);
    },
    save(options: TOptions = {}) {
      return t18('common:actions.save', options);
    },
    submit(options: TOptions = {}) {
      return t18('common:actions.submit', options);
    },
    viewDetails(options: TOptions = {}) {
      return t18('common:actions.viewDetails', options);
    },
  },
  descriptions: {
    logInRequired(options: TOptions = {}) {
      return t18('common:descriptions.logInRequired', options);
    },
  },
  general: {
    and(options: TOptions = {}) {
      return t18('common:general.and', options);
    },
    new(options: TOptions = {}) {
      return t18('common:general.new', options);
    },
    status(options: TOptions = {}) {
      return t18('common:general.status', options);
    },
    success(options: TOptions = {}) {
      return t18('common:general.success', options);
    },
  },
};
export const tAuth = {
  actions: {
    backToLogIn(options: TOptions = {}) {
      return t18('auth:actions.backToLogIn', options);
    },
    changePassword(options: TOptions = {}) {
      return t18('auth:actions.changePassword', options);
    },
    delete(options: TOptions = {}) {
      return t18('auth:actions.delete', options);
    },
    deleteUser(options: TOptions = {}) {
      return t18('auth:actions.deleteUser', options);
    },
    forgotPassword(options: TOptions = {}) {
      return t18('auth:actions.forgotPassword', options);
    },
    hidePassword(options: TOptions = {}) {
      return t18('auth:actions.hidePassword', options);
    },
    login(options: TOptions = {}) {
      return t18('auth:actions.login', options);
    },
    logout(options: TOptions = {}) {
      return t18('auth:actions.logout', options);
    },
    resendEmail(options: TOptions = {}) {
      return t18('auth:actions.resendEmail', options);
    },
    showPassword(options: TOptions = {}) {
      return t18('auth:actions.showPassword', options);
    },
    signUp(options: TOptions = {}) {
      return t18('auth:actions.signUp', options);
    },
    signUpOrLogIn(options: TOptions = {}) {
      return t18('auth:actions.signUpOrLogIn', options);
    },
    updatePassword(options: TOptions = {}) {
      return t18('auth:actions.updatePassword', options);
    },
  },
  descriptions: {
    checkInboxLogIn(options: TOptions<{ email: string; } & Record<string, any>>) {
      return t18('auth:descriptions.checkInboxLogIn', options);
    },
    checkInboxReset(options: TOptions = {}) {
      return t18('auth:descriptions.checkInboxReset', options);
    },
    checkInboxSignUp(options: TOptions<{ email: string; } & Record<string, any>>) {
      return t18('auth:descriptions.checkInboxSignUp', options);
    },
    deleteUserAndGuest(options: TOptions = {}) {
      return t18('auth:descriptions.deleteUserAndGuest', options);
    },
    deleteUserOnly(options: TOptions = {}) {
      return t18('auth:descriptions.deleteUserOnly', options);
    },
    forgotPassword(options: TOptions = {}) {
      return t18('auth:descriptions.forgotPassword', options);
    },
    logInToAccessAccount(options: TOptions<{ operator: string; } & Record<string, any>>) {
      return t18('auth:descriptions.logInToAccessAccount', options);
    },
  },
  fieldErrors: {
    invalidEmail(options: TOptions = {}) {
      return t18('auth:fieldErrors.invalidEmail', options);
    },
    invalidPassword(options: TOptions = {}) {
      return t18('auth:fieldErrors.invalidPassword', options);
    },
    invalidPasswordLength(options: TOptions = {}) {
      return t18('auth:fieldErrors.invalidPasswordLength', options);
    },
    passwordsDoNotMatch(options: TOptions = {}) {
      return t18('auth:fieldErrors.passwordsDoNotMatch', options);
    },
  },
  fields: {
    confirmPassword(options: TOptions = {}) {
      return t18('auth:fields.confirmPassword', options);
    },
    currentPassword(options: TOptions = {}) {
      return t18('auth:fields.currentPassword', options);
    },
    email(options: TOptions = {}) {
      return t18('auth:fields.email', options);
    },
    newPassword(options: TOptions = {}) {
      return t18('auth:fields.newPassword', options);
    },
    password(options: TOptions = {}) {
      return t18('auth:fields.password', options);
    },
    privacyPolicy(options: TOptions = {}) {
      return t18('auth:fields.privacyPolicy', options);
    },
    termsAccept(options: TOptions = {}) {
      return t18('auth:fields.termsAccept', options);
    },
    termsOfServicePolicy(options: TOptions = {}) {
      return t18('auth:fields.termsOfServicePolicy', options);
    },
  },
  headers: {
    changePassword(options: TOptions = {}) {
      return t18('auth:headers.changePassword', options);
    },
    checkInbox(options: TOptions = {}) {
      return t18('auth:headers.checkInbox', options);
    },
    confirmDelete(options: TOptions = {}) {
      return t18('auth:headers.confirmDelete', options);
    },
    enterNewPassword(options: TOptions = {}) {
      return t18('auth:headers.enterNewPassword', options);
    },
    forgotPassword(options: TOptions = {}) {
      return t18('auth:headers.forgotPassword', options);
    },
    forgotPasswordNav(options: TOptions = {}) {
      return t18('auth:headers.forgotPasswordNav', options);
    },
    logIn(options: TOptions = {}) {
      return t18('auth:headers.logIn', options);
    },
    passwordUpdated(options: TOptions = {}) {
      return t18('auth:headers.passwordUpdated', options);
    },
    signUp(options: TOptions = {}) {
      return t18('auth:headers.signUp', options);
    },
    verifyingEmail(options: TOptions = {}) {
      return t18('auth:headers.verifyingEmail', options);
    },
    welcomeToPortal(options: TOptions<{ portal: string; } & Record<string, any>>) {
      return t18('auth:headers.welcomeToPortal', options);
    },
  },
  notifications: {
    changePasswordSessionTimeout(options: TOptions = {}) {
      return t18('auth:notifications.changePasswordSessionTimeout', options);
    },
    doHaveAccount(options: TOptions = {}) {
      return t18('auth:notifications.doHaveAccount', options);
    },
    domainDenied(options: TOptions = {}) {
      return t18('auth:notifications.domainDenied', options);
    },
    doNotHaveAccount(options: TOptions = {}) {
      return t18('auth:notifications.doNotHaveAccount', options);
    },
    emailVerificationFailed(options: TOptions = {}) {
      return t18('auth:notifications.emailVerificationFailed', options);
    },
    failedToChangePassword(options: TOptions = {}) {
      return t18('auth:notifications.failedToChangePassword', options);
    },
    forgotPasswordSubmitError(options: TOptions = {}) {
      return t18('auth:notifications.forgotPasswordSubmitError', options);
    },
    invalidCredentials(options: TOptions = {}) {
      return t18('auth:notifications.invalidCredentials', options);
    },
    malformedSubAddress(options: TOptions = {}) {
      return t18('auth:notifications.malformedSubAddress', options);
    },
    passwordExpired(options: TOptions = {}) {
      return t18('auth:notifications.passwordExpired', options);
    },
    portalLocked(options: TOptions = {}) {
      return t18('auth:notifications.portalLocked', options);
    },
    resendVerificationError(options: TOptions = {}) {
      return t18('auth:notifications.resendVerificationError', options);
    },
    sessionNoLongerValid(options: TOptions = {}) {
      return t18('auth:notifications.sessionNoLongerValid', options);
    },
    subAddressingNotAllowed(options: TOptions = {}) {
      return t18('auth:notifications.subAddressingNotAllowed', options);
    },
    tooManyAttempts(options: TOptions = {}) {
      return t18('auth:notifications.tooManyAttempts', options);
    },
    unableToLogin(options: TOptions = {}) {
      return t18('auth:notifications.unableToLogin', options);
    },
    userLocked(options: TOptions = {}) {
      return t18('auth:notifications.userLocked', options);
    },
  },
};
export const tApp = {
  accountCard: {
    balance(options: TOptions = {}) {
      return t18('app:accountCard.balance', options);
    },
    balanceHiddenText(options: TOptions = {}) {
      return t18('app:accountCard.balanceHiddenText', options);
    },
    credit(options: TOptions = {}) {
      return t18('app:accountCard.credit', options);
    },
    direct(options: TOptions = {}) {
      return t18('app:accountCard.direct', options);
    },
    showQrCode(options: TOptions = {}) {
      return t18('app:accountCard.showQrCode', options);
    },
    spentCreditOf(options: TOptions<{ creditLimit: string; } & Record<string, any>>) {
      return t18('app:accountCard.spentCreditOf', options);
    },
    toggleBalance(options: TOptions = {}) {
      return t18('app:accountCard.toggleBalance', options);
    },
  },
  accountDetails: {
    prepaid(options: TOptions = {}) {
      return t18('app:accountDetails.prepaid', options);
    },
    scanToIdentify(options: TOptions = {}) {
      return t18('app:accountDetails.scanToIdentify', options);
    },
    scanToUseOffer(options: TOptions = {}) {
      return t18('app:accountDetails.scanToUseOffer', options);
    },
  },
  accountList: {
    a11y: {
      firstSlideMessage(options: TOptions = {}) {
        return t18('app:accountList.a11y.firstSlideMessage', options);
      },
      goToAccount(options: TOptions<{ index: string; } & Record<string, any>>) {
        return t18('app:accountList.a11y.goToAccount', options);
      },
      lastSlideMessage(options: TOptions = {}) {
        return t18('app:accountList.a11y.lastSlideMessage', options);
      },
      nextSlideMessage(options: TOptions = {}) {
        return t18('app:accountList.a11y.nextSlideMessage', options);
      },
      previousSlideMessage(options: TOptions = {}) {
        return t18('app:accountList.a11y.previousSlideMessage', options);
      },
    },
    noAccounts(options: TOptions = {}) {
      return t18('app:accountList.noAccounts', options);
    },
    noAccountsDescription(options: TOptions = {}) {
      return t18('app:accountList.noAccountsDescription', options);
    },
  },
  actions: {
    goBack(options: TOptions = {}) {
      return t18('app:actions.goBack', options);
    },
    qrCode(options: TOptions = {}) {
      return t18('app:actions.qrCode', options);
    },
    viewAll(options: TOptions = {}) {
      return t18('app:actions.viewAll', options);
    },
  },
  app: {
    notifications: {
      loading(options: TOptions = {}) {
        return t18('app:app.notifications.loading', options);
      },
    },
    softwareVersion(options: TOptions = {}) {
      return t18('app:app.softwareVersion', options);
    },
    unAuth: {
      header(options: TOptions = {}) {
        return t18('app:app.unAuth.header', options);
      },
      message(options: TOptions = {}) {
        return t18('app:app.unAuth.message', options);
      },
    },
    version(options: TOptions = {}) {
      return t18('app:app.version', options);
    },
  },
  drawer: {
    description(options: TOptions<{ action: string; } & Record<string, any>>) {
      return t18('app:drawer.description', options);
    },
    drawerMenu(options: TOptions = {}) {
      return t18('app:drawer.drawerMenu', options);
    },
    needHelp(options: TOptions = {}) {
      return t18('app:drawer.needHelp', options);
    },
  },
  errorPages: {
    notFound(options: TOptions = {}) {
      return t18('app:errorPages.notFound', options);
    },
    notFoundDescription(options: TOptions = {}) {
      return t18('app:errorPages.notFoundDescription', options);
    },
    unexpectedError(options: TOptions = {}) {
      return t18('app:errorPages.unexpectedError', options);
    },
    unexpectedErrorDescription(options: TOptions = {}) {
      return t18('app:errorPages.unexpectedErrorDescription', options);
    },
  },
  externalLinks: {
    tooltips: {
      externalLink(options: TOptions = {}) {
        return t18('app:externalLinks.tooltips.externalLink', options);
      },
      openInNewTab(options: TOptions<{ dest: string; } & Record<string, any>>) {
        return t18('app:externalLinks.tooltips.openInNewTab', options);
      },
      openLinkInApp(options: TOptions = {}) {
        return t18('app:externalLinks.tooltips.openLinkInApp', options);
      },
    },
  },
  headers: {
    benefits(options: TOptions = {}) {
      return t18('app:headers.benefits', options);
    },
    finaliseProfile(options: TOptions = {}) {
      return t18('app:headers.finaliseProfile', options);
    },
    home(options: TOptions = {}) {
      return t18('app:headers.home', options);
    },
    keyNews(options: TOptions = {}) {
      return t18('app:headers.keyNews', options);
    },
    latestTransactions(options: TOptions = {}) {
      return t18('app:headers.latestTransactions', options);
    },
    menu(options: TOptions = {}) {
      return t18('app:headers.menu', options);
    },
    news(options: TOptions = {}) {
      return t18('app:headers.news', options);
    },
    notifications(options: TOptions = {}) {
      return t18('app:headers.notifications', options);
    },
    ourSiteUnits(options: TOptions = {}) {
      return t18('app:headers.ourSiteUnits', options);
    },
    profile(options: TOptions = {}) {
      return t18('app:headers.profile', options);
    },
    rules(options: TOptions = {}) {
      return t18('app:headers.rules', options);
    },
    showVerification(options: TOptions = {}) {
      return t18('app:headers.showVerification', options);
    },
    siteAccess(options: TOptions = {}) {
      return t18('app:headers.siteAccess', options);
    },
    siteUnits(options: TOptions = {}) {
      return t18('app:headers.siteUnits', options);
    },
    stampCards(options: TOptions = {}) {
      return t18('app:headers.stampCards', options);
    },
    topup(options: TOptions = {}) {
      return t18('app:headers.topup', options);
    },
    transactions(options: TOptions = {}) {
      return t18('app:headers.transactions', options);
    },
    vouchers(options: TOptions = {}) {
      return t18('app:headers.vouchers', options);
    },
    wallet(options: TOptions = {}) {
      return t18('app:headers.wallet', options);
    },
    yourStampCards(options: TOptions = {}) {
      return t18('app:headers.yourStampCards', options);
    },
    yourVouchers(options: TOptions = {}) {
      return t18('app:headers.yourVouchers', options);
    },
  },
  languageOptions: {
    ['en-GB'](options: TOptions = {}) {
      return t18('app:languageOptions.en-GB', options);
    },
    ['en-US'](options: TOptions = {}) {
      return t18('app:languageOptions.en-US', options);
    },
    ['fr-FR'](options: TOptions = {}) {
      return t18('app:languageOptions.fr-FR', options);
    },
    ['nl-NL'](options: TOptions = {}) {
      return t18('app:languageOptions.nl-NL', options);
    },
    ['sv-SE'](options: TOptions = {}) {
      return t18('app:languageOptions.sv-SE', options);
    },
  },
  news: {
    a11y: {
      firstSlideMessage(options: TOptions = {}) {
        return t18('app:news.a11y.firstSlideMessage', options);
      },
      goToArticle(options: TOptions<{ index: string; } & Record<string, any>>) {
        return t18('app:news.a11y.goToArticle', options);
      },
      lastSlideMessage(options: TOptions = {}) {
        return t18('app:news.a11y.lastSlideMessage', options);
      },
      nextSlideMessage(options: TOptions = {}) {
        return t18('app:news.a11y.nextSlideMessage', options);
      },
      previousSlideMessage(options: TOptions = {}) {
        return t18('app:news.a11y.previousSlideMessage', options);
      },
      readArticle(options: TOptions<{ title: string; } & Record<string, any>>) {
        return t18('app:news.a11y.readArticle', options);
      },
    },
    latestNews(options: TOptions = {}) {
      return t18('app:news.latestNews', options);
    },
    newsRelatedTo(options: TOptions<{ name: string; } & Record<string, any>>) {
      return t18('app:news.newsRelatedTo', options);
    },
    newsRelatedToGlobal(options: TOptions<{ name: string; } & Record<string, any>>) {
      return t18('app:news.newsRelatedToGlobal', options);
    },
    noNewsCurrently(options: TOptions = {}) {
      return t18('app:news.noNewsCurrently', options);
    },
    noNewsCurrentlyDescription(options: TOptions = {}) {
      return t18('app:news.noNewsCurrentlyDescription', options);
    },
    showAllNews(options: TOptions = {}) {
      return t18('app:news.showAllNews', options);
    },
  },
  notifications: {
    categories: {
      EVENTS(options: TOptions = {}) {
        return t18('app:notifications.categories.EVENTS', options);
      },
      GENERAL(options: TOptions = {}) {
        return t18('app:notifications.categories.GENERAL', options);
      },
      MENU_CHANGES(options: TOptions = {}) {
        return t18('app:notifications.categories.MENU_CHANGES', options);
      },
      OFFERS(options: TOptions = {}) {
        return t18('app:notifications.categories.OFFERS', options);
      },
      ORDER_UPDATES(options: TOptions = {}) {
        return t18('app:notifications.categories.ORDER_UPDATES', options);
      },
    },
    categoriesTitle(options: TOptions = {}) {
      return t18('app:notifications.categoriesTitle', options);
    },
    categoryDescriptions: {
      EVENTS(options: TOptions = {}) {
        return t18('app:notifications.categoryDescriptions.EVENTS', options);
      },
      GENERAL(options: TOptions = {}) {
        return t18('app:notifications.categoryDescriptions.GENERAL', options);
      },
      MENU_CHANGES(options: TOptions = {}) {
        return t18('app:notifications.categoryDescriptions.MENU_CHANGES', options);
      },
      OFFERS(options: TOptions = {}) {
        return t18('app:notifications.categoryDescriptions.OFFERS', options);
      },
      ORDER_UPDATES(options: TOptions = {}) {
        return t18('app:notifications.categoryDescriptions.ORDER_UPDATES', options);
      },
    },
    failedToUpdate(options: TOptions = {}) {
      return t18('app:notifications.failedToUpdate', options);
    },
    saveChanges(options: TOptions = {}) {
      return t18('app:notifications.saveChanges', options);
    },
  },
  order: {
    deliveryTime(options: TOptions<{ date: string; time: string; } & Record<string, any>>) {
      return t18('app:order.deliveryTime', options);
    },
    error(options: TOptions = {}) {
      return t18('app:order.error', options);
    },
    inProgress(options: TOptions = {}) {
      return t18('app:order.inProgress', options);
    },
    order(options: TOptions<{ orderId: string; } & Record<string, any>>) {
      return t18('app:order.order', options);
    },
    pickUpTime(options: TOptions<{ date: string; time: string; } & Record<string, any>>) {
      return t18('app:order.pickUpTime', options);
    },
    statusDescription: {
      CANCELLED(options: TOptions = {}) {
        return t18('app:order.statusDescription.CANCELLED', options);
      },
      DELIVERED(options: TOptions = {}) {
        return t18('app:order.statusDescription.DELIVERED', options);
      },
      ERROR(options: TOptions = {}) {
        return t18('app:order.statusDescription.ERROR', options);
      },
      FSGM_FAILED(options: TOptions = {}) {
        return t18('app:order.statusDescription.FSGM_FAILED', options);
      },
      PAYMENT_FAILED(options: TOptions = {}) {
        return t18('app:order.statusDescription.PAYMENT_FAILED', options);
      },
      PENDING(options: TOptions = {}) {
        return t18('app:order.statusDescription.PENDING', options);
      },
      PICKED_UP(options: TOptions = {}) {
        return t18('app:order.statusDescription.PICKED_UP', options);
      },
      REFUNDED(options: TOptions = {}) {
        return t18('app:order.statusDescription.REFUNDED', options);
      },
      SHOP_CONFIRMED(options: TOptions = {}) {
        return t18('app:order.statusDescription.SHOP_CONFIRMED', options);
      },
      SHOP_RECEIVED(options: TOptions = {}) {
        return t18('app:order.statusDescription.SHOP_RECEIVED', options);
      },
      WAIT_DELIVERY_PICKUP(options: TOptions = {}) {
        return t18('app:order.statusDescription.WAIT_DELIVERY_PICKUP', options);
      },
    },
    summary: {
      ERROR(options: TOptions = {}) {
        return t18('app:order.summary.ERROR', options);
      },
      SHOP_CONFIRMED(options: TOptions = {}) {
        return t18('app:order.summary.SHOP_CONFIRMED', options);
      },
      SHOP_RECEIVED(options: TOptions = {}) {
        return t18('app:order.summary.SHOP_RECEIVED', options);
      },
      WAIT_DELIVERY_PICKUP(options: TOptions = {}) {
        return t18('app:order.summary.WAIT_DELIVERY_PICKUP', options);
      },
    },
  },
  profile: {
    confirmNewPassword(options: TOptions = {}) {
      return t18('app:profile.confirmNewPassword', options);
    },
    emailAddress(options: TOptions = {}) {
      return t18('app:profile.emailAddress', options);
    },
    failedToChangePassword(options: TOptions = {}) {
      return t18('app:profile.failedToChangePassword', options);
    },
    failedToUpdateProfile(options: TOptions = {}) {
      return t18('app:profile.failedToUpdateProfile', options);
    },
    finaliseProfileDescription(options: TOptions = {}) {
      return t18('app:profile.finaliseProfileDescription', options);
    },
    firstName(options: TOptions = {}) {
      return t18('app:profile.firstName', options);
    },
    joinedAt(options: TOptions<{ date: string; } & Record<string, any>>) {
      return t18('app:profile.joinedAt', options);
    },
    language(options: TOptions = {}) {
      return t18('app:profile.language', options);
    },
    lastName(options: TOptions = {}) {
      return t18('app:profile.lastName', options);
    },
    locale(options: TOptions = {}) {
      return t18('app:profile.locale', options);
    },
  },
  pushNotifications: {
    descriptionBody1(options: TOptions<{ operatorDisplayName: string; } & Record<string, any>>) {
      return t18('app:pushNotifications.descriptionBody1', options);
    },
    descriptionBody2(options: TOptions = {}) {
      return t18('app:pushNotifications.descriptionBody2', options);
    },
    enable(options: TOptions = {}) {
      return t18('app:pushNotifications.enable', options);
    },
    errorEnabling(options: TOptions = {}) {
      return t18('app:pushNotifications.errorEnabling', options);
    },
    maybeLater(options: TOptions = {}) {
      return t18('app:pushNotifications.maybeLater', options);
    },
    switchDescription(options: TOptions<{ operatorDisplayName: string; } & Record<string, any>>) {
      return t18('app:pushNotifications.switchDescription', options);
    },
    switchLabel(options: TOptions = {}) {
      return t18('app:pushNotifications.switchLabel', options);
    },
    switchTagline(options: TOptions<{ operatorDisplayName: string; } & Record<string, any>>) {
      return t18('app:pushNotifications.switchTagline', options);
    },
    title(options: TOptions = {}) {
      return t18('app:pushNotifications.title', options);
    },
  },
  rules: {
    appliedAutomatically(options: TOptions = {}) {
      return t18('app:rules.appliedAutomatically', options);
    },
    chooseWhenPaying(options: TOptions = {}) {
      return t18('app:rules.chooseWhenPaying', options);
    },
    forAccounts(options: TOptions<{ accounts: string; } & Record<string, any>>) {
      return t18('app:rules.forAccounts', options);
    },
    noActiveRules(options: TOptions = {}) {
      return t18('app:rules.noActiveRules', options);
    },
    noActiveRulesDescription(options: TOptions = {}) {
      return t18('app:rules.noActiveRulesDescription', options);
    },
    notCombinableWith(options: TOptions<{ rules: string; } & Record<string, any>>) {
      return t18('app:rules.notCombinableWith', options);
    },
  },
  siteUnits: {
    a11y: {
      firstSlideMessage(options: TOptions = {}) {
        return t18('app:siteUnits.a11y.firstSlideMessage', options);
      },
      goToSiteUnit(options: TOptions<{ index: string; } & Record<string, any>>) {
        return t18('app:siteUnits.a11y.goToSiteUnit', options);
      },
      lastSlideMessage(options: TOptions = {}) {
        return t18('app:siteUnits.a11y.lastSlideMessage', options);
      },
      nextSlideMessage(options: TOptions = {}) {
        return t18('app:siteUnits.a11y.nextSlideMessage', options);
      },
      previousSlideMessage(options: TOptions = {}) {
        return t18('app:siteUnits.a11y.previousSlideMessage', options);
      },
    },
    addAccess: {
      title(options: TOptions = {}) {
        return t18('app:siteUnits.addAccess.title', options);
      },
    },
    address(options: TOptions = {}) {
      return t18('app:siteUnits.address', options);
    },
    empty: {
      button(options: TOptions = {}) {
        return t18('app:siteUnits.empty.button', options);
      },
      inputLabel(options: TOptions = {}) {
        return t18('app:siteUnits.empty.inputLabel', options);
      },
      invalidCode(options: TOptions = {}) {
        return t18('app:siteUnits.empty.invalidCode', options);
      },
      subtitle(options: TOptions = {}) {
        return t18('app:siteUnits.empty.subtitle', options);
      },
      title(options: TOptions = {}) {
        return t18('app:siteUnits.empty.title', options);
      },
    },
    favorite(options: TOptions = {}) {
      return t18('app:siteUnits.favorite', options);
    },
    favorites(options: TOptions = {}) {
      return t18('app:siteUnits.favorites', options);
    },
    noAccess: {
      subtitle(options: TOptions = {}) {
        return t18('app:siteUnits.noAccess.subtitle', options);
      },
      title(options: TOptions = {}) {
        return t18('app:siteUnits.noAccess.title', options);
      },
    },
  },
  stampCards: {
    a11y: {
      firstSlideMessage(options: TOptions = {}) {
        return t18('app:stampCards.a11y.firstSlideMessage', options);
      },
      goToStampCard(options: TOptions<{ index: string; } & Record<string, any>>) {
        return t18('app:stampCards.a11y.goToStampCard', options);
      },
      lastSlideMessage(options: TOptions = {}) {
        return t18('app:stampCards.a11y.lastSlideMessage', options);
      },
      nextSlideMessage(options: TOptions = {}) {
        return t18('app:stampCards.a11y.nextSlideMessage', options);
      },
      previousSlideMessage(options: TOptions = {}) {
        return t18('app:stampCards.a11y.previousSlideMessage', options);
      },
      viewStampCard(options: TOptions = {}) {
        return t18('app:stampCards.a11y.viewStampCard', options);
      },
    },
    noExpirationDate(options: TOptions = {}) {
      return t18('app:stampCards.noExpirationDate', options);
    },
    noStampCards(options: TOptions = {}) {
      return t18('app:stampCards.noStampCards', options);
    },
    rewardDescription(options: TOptions<{ stampCardTitle: string; } & Record<string, any>>) {
      return t18('app:stampCards.rewardDescription', options);
    },
    rewardHeader(options: TOptions = {}) {
      return t18('app:stampCards.rewardHeader', options);
    },
    validUntil(options: TOptions<{ validUntil: string; } & Record<string, any>>) {
      return t18('app:stampCards.validUntil', options);
    },
  },
  topup: {
    amount(options: TOptions = {}) {
      return t18('app:topup.amount', options);
    },
    chooseAmount(options: TOptions = {}) {
      return t18('app:topup.chooseAmount', options);
    },
    customAmount(options: TOptions = {}) {
      return t18('app:topup.customAmount', options);
    },
    exceedsLimit(options: TOptions = {}) {
      return t18('app:topup.exceedsLimit', options);
    },
    invalidAmount(options: TOptions = {}) {
      return t18('app:topup.invalidAmount', options);
    },
    payment(options: TOptions = {}) {
      return t18('app:topup.payment', options);
    },
    stripeLoadError(options: TOptions = {}) {
      return t18('app:topup.stripeLoadError', options);
    },
    success(options: TOptions = {}) {
      return t18('app:topup.success', options);
    },
    termsAccept(options: TOptions = {}) {
      return t18('app:topup.termsAccept', options);
    },
    termsAndConditions(options: TOptions = {}) {
      return t18('app:topup.termsAndConditions', options);
    },
  },
  transactionList: {
    description(options: TOptions = {}) {
      return t18('app:transactionList.description', options);
    },
    noTransactions(options: TOptions = {}) {
      return t18('app:transactionList.noTransactions', options);
    },
  },
  transactionStatusDescriptions: {
    approved(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.approved', options);
    },
    cancelled(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.cancelled', options);
    },
    delivered(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.delivered', options);
    },
    ready(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.ready', options);
    },
    received(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.received', options);
    },
    refunded(options: TOptions = {}) {
      return t18('app:transactionStatusDescriptions.refunded', options);
    },
  },
  transactionStatusTitles: {
    approved(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.approved', options);
    },
    cancelled(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.cancelled', options);
    },
    delivered(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.delivered', options);
    },
    ready(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.ready', options);
    },
    received(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.received', options);
    },
    refunded(options: TOptions = {}) {
      return t18('app:transactionStatusTitles.refunded', options);
    },
  },
  transactionSummary: {
    account(options: TOptions = {}) {
      return t18('app:transactionSummary.account', options);
    },
    accountType(options: TOptions = {}) {
      return t18('app:transactionSummary.accountType', options);
    },
    change(options: TOptions = {}) {
      return t18('app:transactionSummary.change', options);
    },
    check(options: TOptions = {}) {
      return t18('app:transactionSummary.check', options);
    },
    client(options: TOptions = {}) {
      return t18('app:transactionSummary.client', options);
    },
    costCenter(options: TOptions = {}) {
      return t18('app:transactionSummary.costCenter', options);
    },
    department(options: TOptions = {}) {
      return t18('app:transactionSummary.department', options);
    },
    guest(options: TOptions = {}) {
      return t18('app:transactionSummary.guest', options);
    },
    guestDetails(options: TOptions = {}) {
      return t18('app:transactionSummary.guestDetails', options);
    },
    identifier(options: TOptions = {}) {
      return t18('app:transactionSummary.identifier', options);
    },
    newBalance(options: TOptions = {}) {
      return t18('app:transactionSummary.newBalance', options);
    },
    oldBalance(options: TOptions = {}) {
      return t18('app:transactionSummary.oldBalance', options);
    },
    payment(options: TOptions = {}) {
      return t18('app:transactionSummary.payment', options);
    },
    total(options: TOptions = {}) {
      return t18('app:transactionSummary.total', options);
    },
    transactionSummary(options: TOptions = {}) {
      return t18('app:transactionSummary.transactionSummary', options);
    },
    vat(options: TOptions<{ vatRate: string; } & Record<string, any>>) {
      return t18('app:transactionSummary.vat', options);
    },
    vatTotal(options: TOptions = {}) {
      return t18('app:transactionSummary.vatTotal', options);
    },
    viewOrder(options: TOptions = {}) {
      return t18('app:transactionSummary.viewOrder', options);
    },
  },
  transactionType: {
    CHARGE(options: TOptions = {}) {
      return t18('app:transactionType.CHARGE', options);
    },
    CREDIT_RESET(options: TOptions = {}) {
      return t18('app:transactionType.CREDIT_RESET', options);
    },
    DIRECT_PAYMENT(options: TOptions = {}) {
      return t18('app:transactionType.DIRECT_PAYMENT', options);
    },
    INIT_BALANCE(options: TOptions = {}) {
      return t18('app:transactionType.INIT_BALANCE', options);
    },
    REFUND(options: TOptions = {}) {
      return t18('app:transactionType.REFUND', options);
    },
    REIMBURSEMENT(options: TOptions = {}) {
      return t18('app:transactionType.REIMBURSEMENT', options);
    },
    TOPUP(options: TOptions = {}) {
      return t18('app:transactionType.TOPUP', options);
    },
  },
  versionUpdate: {
    iosAppStoreIdMissing(options: TOptions = {}) {
      return t18('app:versionUpdate.iosAppStoreIdMissing', options);
    },
    optionalDescription(options: TOptions = {}) {
      return t18('app:versionUpdate.optionalDescription', options);
    },
    optionalHeader(options: TOptions = {}) {
      return t18('app:versionUpdate.optionalHeader', options);
    },
    requiredDescription(options: TOptions = {}) {
      return t18('app:versionUpdate.requiredDescription', options);
    },
    requiredHeader(options: TOptions = {}) {
      return t18('app:versionUpdate.requiredHeader', options);
    },
    skipButton(options: TOptions = {}) {
      return t18('app:versionUpdate.skipButton', options);
    },
    updateButton(options: TOptions = {}) {
      return t18('app:versionUpdate.updateButton', options);
    },
  },
  vouchers: {
    a11y: {
      firstSlideMessage(options: TOptions = {}) {
        return t18('app:vouchers.a11y.firstSlideMessage', options);
      },
      goToVoucher(options: TOptions<{ index: string; } & Record<string, any>>) {
        return t18('app:vouchers.a11y.goToVoucher', options);
      },
      lastSlideMessage(options: TOptions = {}) {
        return t18('app:vouchers.a11y.lastSlideMessage', options);
      },
      nextSlideMessage(options: TOptions = {}) {
        return t18('app:vouchers.a11y.nextSlideMessage', options);
      },
      previousSlideMessage(options: TOptions = {}) {
        return t18('app:vouchers.a11y.previousSlideMessage', options);
      },
      viewVoucher(options: TOptions = {}) {
        return t18('app:vouchers.a11y.viewVoucher', options);
      },
    },
    active(options: TOptions = {}) {
      return t18('app:vouchers.active', options);
    },
    allSites(options: TOptions = {}) {
      return t18('app:vouchers.allSites', options);
    },
    lastClaimed(options: TOptions<{ lastClaimDate: string; } & Record<string, any>>) {
      return t18('app:vouchers.lastClaimed', options);
    },
    noActiveVouchers(options: TOptions = {}) {
      return t18('app:vouchers.noActiveVouchers', options);
    },
    noActiveVouchersDescription(options: TOptions = {}) {
      return t18('app:vouchers.noActiveVouchersDescription', options);
    },
    noRecentlyUsedVouchers(options: TOptions = {}) {
      return t18('app:vouchers.noRecentlyUsedVouchers', options);
    },
    noUpcomingVouchers(options: TOptions = {}) {
      return t18('app:vouchers.noUpcomingVouchers', options);
    },
    noUsedVouchers(options: TOptions = {}) {
      return t18('app:vouchers.noUsedVouchers', options);
    },
    noUsedVouchersDescription(options: TOptions = {}) {
      return t18('app:vouchers.noUsedVouchersDescription', options);
    },
    recentlyUsed(options: TOptions = {}) {
      return t18('app:vouchers.recentlyUsed', options);
    },
    upcoming(options: TOptions = {}) {
      return t18('app:vouchers.upcoming', options);
    },
    used(options: TOptions = {}) {
      return t18('app:vouchers.used', options);
    },
    validAt(options: TOptions<{ validAt: string; } & Record<string, any>>) {
      return t18('app:vouchers.validAt', options);
    },
    voucherId(options: TOptions<{ voucherId: string; } & Record<string, any>>) {
      return t18('app:vouchers.voucherId', options);
    },
  },
};
